module.exports = __webpack_public_path__ + "static/media/icon-edit.d78839cb.svg";